module.exports = __webpack_public_path__ + "img/20231221.942dec08.jpg";